import { render } from "./AdminVoiceOfGodContent.vue?vue&type=template&id=83b47efe&scoped=true"
import script from "./AdminVoiceOfGodContent.vue?vue&type=script&lang=js"
export * from "./AdminVoiceOfGodContent.vue?vue&type=script&lang=js"

import "./AdminVoiceOfGodContent.vue?vue&type=style&index=0&id=83b47efe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b47efe"]])

export default __exports__